import React, {FunctionComponent, createContext, useContext, useState} from 'react';
import { ScaleExercise } from '../../models/scale-exercise';
import { PitchClassName } from '../../models/pitch-class';
import { ModeName } from '../../models/mode';
import { RangeName } from '../../models/range';

const ExerciseContext = createContext<{
  data: ScaleExercise,
  update: (newExercise: ScaleExercise) => any;
} | null>(null);

export const ExerciseProvider: FunctionComponent = ({children}) => {
  const [exercise, setExercise] = useState<ScaleExercise>({
    id: '',
    pitch_class: PitchClassName.C,
    mode: ModeName.Major,
    range: RangeName.SingleOctave
  });

  function update(newExercise: ScaleExercise) {
    setExercise(newExercise);
  }

  return <ExerciseContext.Provider value={{data: exercise, update}}>
    {children}
  </ExerciseContext.Provider>
};

export const useProvidedExercise = () => {
  const exerciseStore = useContext(ExerciseContext);

  if (exerciseStore === null) {
    throw new Error('useProvidedExercise must be used within a ExerciseProvider')
  }

  return exerciseStore;
}
